/** Rótulos em PT-BR dos enums de cliente. O banco guarda o valor canônico. */
import type { ClientStatus, ClientTier } from "@unik/shared";

export const TIER_LABEL: Record<ClientTier, string> = {
  mentoria: "Mentoria",
  consultoria: "Consultoria",
  imersao: "Imersão",
};

export const STATUS_LABEL: Record<ClientStatus, string> = {
  active: "Ativo",
  suspended: "Suspenso",
  archived: "Arquivado",
};
